export default __webpack_public_path__ + "static/media/ttdy_cover.2600b005.jpg";